/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-useless-constructor */
import { reaction } from 'mobx';
import { advHas } from '@src/slide/infrastructure/module/independent/assert/get-set';
import { ObserverCallBack } from '@src/slide/domain/ui-model/changesetManager/change-set-engine.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import BaseObserver from './baseObserver';
import type { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
export default class ShapeModelObserver extends BaseObserver {
    declare public model: IShapeModel;
    private mediaManager?: IMediaManager;

    public constructor(model, options) {
        super(model, options);
        this.mediaManager = options.mediaManager;
    }

    getObserveData(): Record<string, any> {
        const { operationFrame, operatingGraphicInfo, previewChange, editorEnterFocus } = this.model;
        const displayMode = advHas(this.model.props.addon, 'displayMode');
        const { isAttachmentShown } = this.model;
        return {
            selected: this.model.selected,
            editorEnterFocus,
            operatingGraphicInfo,
            operationFrame,
            previewChange,
            displayMode,
            isAttachmentShown,
            prevIframeSelected: this.model.selected && this.mediaManager?.prevIframeSelected,
            currentIframeSelected: this.model.selected
                && this.mediaManager?.currentIframeSelected,
        };
    }

    /**
     * 因为只有 shapeModel 上有 updateState 属性，所以 cb 要额外传该对象
     * @param callback
     */
    public addLocalChangeObserver(callback: ObserverCallBack): void {
        if (callback && this.callbacks.indexOf(callback) < 0) {
            this.callbacks.push(callback);
        }
        if (this.callbacks.length > 0 && !this.actionDispose) {
            this.actionDispose = reaction(() => (this.getObserveData()), (obj) => {
                this.notifyLocalChange(obj, { updateState: this.model.getUpdateState?.() });
            });
        }
    }
}
